// this is in a separate module so it can be mocked easily
export default require.context('../../../style/images/flag-icons/', true, /^\.\/.*\.png$/)



// WEBPACK FOOTER //
// ../~/@master/webinfra-frontend-components/src/components/CountriesSelect/flags.js